import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, Subscription } from 'rxjs';
import User from 'models/user/user.model';
import Project from 'models/project/project.model';
import ProjectPermission from 'models/project-permission/project-permission.model';
import { UserService } from 'services/user/user.service';
import { ProjectService } from 'services/project/project.service';
import { TicketService } from 'services/ticket/ticket.service';

@Component({
  selector: 'app-get-project',
  host: {
    class: 'get-project-wrapper',
  },
  templateUrl: './get-project.component.html',
  styleUrls: ['./get-project.component.scss'],
})
export class GetProjectComponent implements OnInit, OnDestroy {
  public instance: Project = new Project();
  public user: User = new User();
  public projectPermission: ProjectPermission = new ProjectPermission();

  private instanceSubscription: Subscription;
  private projectPermissionSubscription: Subscription;
  private userSubscription: Subscription;
  private routeSubscription: Subscription;
  public hasSettingsBtn: boolean = false;
  public refSubject = new BehaviorSubject<boolean>(false);

  constructor(
    private route: ActivatedRoute,
    public router: Router,
    public userService: UserService,
    public projectService: ProjectService,
    public ticketService: TicketService,
  ) { }

  async ngOnInit() {
    this.userSubscription = this.userService.getCurrentUser().subscribe((user) => this.user = user);
    const params = this.route.snapshot.queryParams;
    if (params.id) {
      await this.projectService.select(params.id);
    }
    this.projectPermissionSubscription = this.projectService.getSelectedPermissions().subscribe(async(permission) => {
      this.projectPermission = permission;
      this.hasSettingsBtn = await this.projectService.hasSettingsButton(this.instance, this.user, this.projectPermission);
    });
    this.instanceSubscription = this.projectService.getSelectedInstance().subscribe(async(instance) => {
      this.instance = instance;
      this.hasSettingsBtn = await this.projectService.hasSettingsButton(this.instance, this.user, this.projectPermission);
    });
  }

  edit() {
    this.router.navigate(['/project/edit'], { queryParams: { id: this.instance.id } });
  }

  back() {
    this.router.navigate([`/ou/get/${this.instance.organizationUnit.id}`]);
  }

  time() {
    return this.instance.createdAt.toLocaleDateString().split('/').reverse().join('-');
  }

  refresh() {
    this.refSubject.next(true);
  }

  ngOnDestroy() {
    if (this.instanceSubscription) {
      this.instanceSubscription.unsubscribe();
    }
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
    if (this.projectPermissionSubscription) {
      this.projectPermissionSubscription.unsubscribe();
    }
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
  }
}
